export const GET_ALL_TAGS = 'GET_ALL_TAGS'
export const GET_ALL_RAMAIS = 'GET_ALL_RAMAIS'
export const GET_ALL_CONFERENCIAS = 'GET_ALL_CONFERENCIAS'
export const GET_ALL_CENTRO_DE_CUSTOS = 'GET_ALL_CENTRO_DE_CUSTOS'
export const GET_DADOS_RELATORIO = 'GET_DADOS_RELATORIO'
